import Icon from '@mui/icons-material/AttachFile';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function FileIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
